<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script>
export default {
  name: 'App',
  
}
</script>

<style lang="less">
*{
  padding: 0;
  margin: 0
}
.el-popover .popoverH{	
		width:356px;
		height:260px;
		overflow-y: scroll;
	}
#app {
  height: 100%;
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
}
.el-table{
    .el-table__fixed{
      height: auto!important;
      bottom: 16px!important;
      &::before{
        background-color: transparent;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/App.vue